<template>
  <div class="ma-10">
    <Loading v-if="isLoading" />
    <Popup
      :message="message"
      v-if="isPopup"
      @close="() => (isPopup = false)"
    />
    <div class="top-container-box">
      <h1>Kampus Merdeka</h1>
      <div>
        <Button
          icon="+"
          outline
          name="Create Program"
          style="background-color: #3b54d9; color: #ffffff; width: 200px"
          @click="() => $router.push('/kampus-merdeka/new')"
        />
      </div>
    </div>
    <v-row>
      <v-col cols="6">
        <div class="action-head">
          <div class="f-search">
            <div>
              <v-text-field
                v-model="filter.name"
                type="text"
                class="f-input"
                placeholder="Search..."
                clearable
                dense
                flat
                solo
                style="
                  padding-top: 5px;
                  padding-left: 5px;
                  width: 448px;
                  border-radius: 14px;
                "
                @input="() => getKampusMerdeka()"
              ></v-text-field>
            </div>
            <div class="f-search-ic">
              <img
                src="/img/icons/search.png"
                style="width: 100%"
                alt="Search Ic"
              />
            </div>
          </div>
        </div>
      </v-col>
      
    </v-row>
    <NewTable
      :headers="headers"
      :rows="kampus_merdeka"
      :currentPage="currentPage"
      :totalPages="total"
      :totalData="totalData"
      :customColumns="customColumns"
      :perPage="perPage"
      :onEdit="editItem"
      :onView="watchItem"
      :onDelete="onDelete"
      :onPageChange="getKampusMerdeka"
    />
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import Loading from "@/components/ilustration/Loading.vue";
import Popup from "@/components/others/Popup.vue";
import NewTable from "@/components/Tabel.vue";
// import FilterIcon from "@/components/icons/Filter.vue";
// import FilterModal from "@/components/FilterModal.vue";
import getAuthentification from "@/utils/badrequest.js";

export default {
  name: "KampusMerdeka",
  components: {
    Button,
    Loading,
    Popup,
    NewTable,
    // FilterIcon,
    // FilterModal,
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      total: 0,
      perPage: 10,
      totalData: 0,
      message: "",
      isPopup: false,
      isFilterActive: false,
      showFilterModal: false,
      filter: {
        name: "",
        sort_by: "desc",
      },
      filterModal: [
        {
          title: "Urutkan",
          name: "sort_by",
          items: [
            {
              name: "Terlama",
              value: "asc",
            },
            {
              name: "Terbaru",
              value: "desc",
            },
          ],
        },
      ],
      headers: [
        {
          text: "NAME",
          field: "name",
          width: 350,
        },
        {
          text: "QUOTA",
          field: "quota",
          width: 88,
        },
        {
          text: "SKS",
          field: "sks",
          width: 72,
        },
        {
          text: "ACTIVITY TYPE",
          field: "activity_type",
          width: 160,
        },
      ],
      kampus_merdeka: [],
      customColumns: [],
    };
  },
  methods: {
    async getKampusMerdeka(page) {
      if (!page) page = this.currentPage;
      else this.currentPage = page;

      this.isLoading = true;
      try {
        const response = await this.$crm_http.get(
          `/v1/kampus-merdeka?page=${page}&per_page=${this.perPage}&sort_by=${this.filter.sort_by}&name=${this.filter.name || ""}`
        );
        this.kampus_merdeka = response.data.data.kampus_merdeka.map((item, index) => ({
          id: item.id,
          no: (this.currentPage - 1) * this.perPage + index + 1,
          name: item.name,
          quota: item.quota,
          sks: item.sks,
          activity_type: item.activity_type,
        }));
        const t = parseInt(response.data.data.total);
        this.total = Math.ceil(t / this.perPage) || 1;
        this.totalData = response.data.data.total;
        if (this.currentPage > this.total) {
          this.currentPage = this.total;
          this.getKampusMerdeka();
        }
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    watchItem(id) {
      this.$router.push("/kampus-merdeka/watch/" + id);
    },
    editItem(id) {
      this.$router.push("/kampus-merdeka/edit/" + id);
    },
    async onDelete(id) {
      this.isLoading = true;
      try {
        await this.$crm_http.delete("/v1/kampus-merdeka/" + id);
        this.getKampusMerdeka();
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to delete data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    clearFilter() {
      this.isFilterActive = false;
      this.filter = {
        name: "",
        sort_by: "desc",
      };
      this.getKampusMerdeka();
    },
    handleClearButtonClick() {
      this.filter = {
        name: "",
        sort_by: this.filter.sort_by,
      };
      this.updateIsFilterActive();
    },
    updateIsFilterActive() {
      this.isFilterActive = !(
        this.filter.sort_by === "desc" &&
        !this.filter.name
      );
    },
  },
  beforeCreate() {
    getAuthentification();
  },
  mounted() {
    this.getKampusMerdeka();
  },
};
</script>

<style scoped>
.action-head {
  margin-top: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.f-search {
  border: 1px solid #d3d6e1;
  width: 100%;
  height: 48px;
  gap: 10px;
  display: flex;
  border-radius: 10px;
  background-color: white;
}
.f-search-ic {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  margin-right: 18px;
}
.f-input {
  width: 86%;
  background: transparent;
  border: none;
}
.f-input:focus {
  background: transparent;
  border: none;
  outline-width: 0;
}
.top-container-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.count-data {
  position: relative;
  top: -60px;
  width: 30%;
}
.no-pagination {
  margin-top: 20px;
  margin-left: 5px;
}
</style>